document.addEventListener("alpine:init", () => {
    window.Alpine.data("fileUploadModal", () => ({
        modal_instance: null,
        init() {
            this.modal_instance = new window.bootstrap.Modal(this.$root);
        },
        cancelUpload() {
            const clear_upload = new Event("clear-upload");
            document.dispatchEvent(clear_upload);
        },
    }));
});
